var shell = require('shelljs')

function ssh(yargs) {

	// var stack = ['a', 'b'].includes(yargs.argv._[1]) ? yargs.argv._[1] : 'a'

	// shell.exec(`ssh sbxwebservices${stack}.sbx.avtr.net`)
	console.log('coming soon')
}

module.exports = ssh


// WEBPACK FOOTER //
// ./src/commands/ssh.js